import { Building2 } from 'lucide-react'
import { EntityCard } from '#app/routes/mocra+/_form+/components/entity-card.tsx'
import { FACILITY_COPY } from '#app/routes/mocra+/_form+/components/facilities/constants.ts'
import {
	facilityCardTitle,
	facilityFeiDescription,
	type FacilityDraft,
} from '#app/routes/mocra+/_form+/components/facilities/types.ts'

type Props = {
	readonly index: number
	readonly facility: FacilityDraft
	readonly onEdit: () => void
	readonly onRemove?: () => void
	readonly removeDisabled?: boolean
	readonly errors?: readonly string[]
}

export function FacilityCard({
	index,
	facility,
	onEdit,
	onRemove,
	removeDisabled,
	errors,
}: Props) {
	const title = facilityCardTitle(facility, index)
	const description = facilityFeiDescription(facility)
	const hasErrors = Boolean(errors && errors.length > 0)

	return (
		<EntityCard
			title={title}
			description={hasErrors ? `${description} • Needs attention` : description}
			onEdit={onEdit}
			onRemove={onRemove}
			removeDisabled={removeDisabled}
			removeLabel="Remove"
			removeConfirmTitle={FACILITY_COPY.actions.removeFacilityConfirmTitle}
			removeConfirmDescription={
				FACILITY_COPY.actions.removeFacilityConfirmDescription
			}
			icon={
				<Building2
					className="text-muted-foreground h-3.5 w-3.5"
					aria-hidden="true"
				/>
			}
			className={
				hasErrors
					? 'border-destructive/40 ring-destructive/40 ring-1'
					: undefined
			}
		/>
	)
}
